import moment from "moment";
import { desformatarCPFCNPJ, desformatarTelefone, desformatarValorMonetario } from "../../../../../helpers/unmask";
import { IRascunhoArquivo } from "../../../../../types/api/financeiro/pesquisar-rascunhos";
import { ISolicitarAnaliseCreditoInput } from "../../../../../types/mutations/solicitar-analise-credito";
import {
    TInfoDadosPropriedade
} from "../../../../../components/DetalheProcessoDialog/Sessoes/Processo/StepperTarefas/LabelContent/InfoBox/InfoDadosPropriedade/InfoDadosPropriedade";

export function tratativaEnvioForm(
    cliente: any,
    attCadastral: any,
    dadosProp: any,
    dadosSolicitacao: any,
    enviarAnexos: any,
): ISolicitarAnaliseCreditoInput {
    let formData = new FormData();

    for (const chave in enviarAnexos) {
        if (Object.prototype.hasOwnProperty.call(enviarAnexos, chave)) {
            const file = enviarAnexos[chave as keyof typeof enviarAnexos];
            if (file) {
                formData.append(chave, file);
            }
        }
    }

    let params: ISolicitarAnaliseCreditoInput = {
        tipo_publico: cliente.tipo_publico,
        codigo_publico: Number(cliente.codigo_publico),
        possui_conjuge: attCadastral.possuiConjuge === "Não" ? "Nao" : attCadastral.possuiConjuge,
        telefone: desformatarTelefone(attCadastral.telefone),
        email: attCadastral.email,
        endereco: attCadastral.endereco,
        numero: attCadastral.numero,
        complemento: attCadastral.complemento,
        bairro: attCadastral.bairro,
        uf: attCadastral.uf,
        cidade: attCadastral.cidade,

        propriedades: dadosProp.map((prop: any) => ({
            descricao: "",
            nome_propriedade: prop.nome,
            propriedade_propria: prop.propriaProp === "Não" ? "Nao" : prop.propriaProp,
            tamanho: Number(prop.tamanho),

            arrendatario: prop.arrendatario === "Não" ? "Nao" : prop.arrendatario,
            vencimento_contrato: prop.arrendatario === "Sim" ? prop.vencimentoContrato.format('YYYY-MM-DD') : undefined,

            produtor_leite: prop.leite.produtor === "Não" ? "Nao" : prop.leite.produtor,
            media_diaria_leite: prop.leite.produtor === "Sim" ? Number(prop.leite.mediaDiaria) : undefined,
            qtd_vacas: prop.leite.produtor === "Sim" ? Number(prop.leite.qtdVacas) : undefined,
            valor_leite: prop.leite.produtor === "Sim" ? desformatarValorMonetario(prop.leite.valor) : undefined,

            produtor_cafe: prop.cafe.produtor === "Não" ? "Nao" : prop.cafe.produtor,
            qtd_sacas_cafe: prop.cafe.produtor === "Sim" ? Number(prop.cafe.qtdSacas) : undefined,
            qtd_ha_cafe: prop.cafe.produtor === "Sim" ? Number(prop.cafe.qtdHa) : undefined,
            valor_cafe: prop.cafe.produtor === "Sim" ? desformatarValorMonetario(prop.cafe.valor) : undefined,

            produtor_milho: prop.milho.produtor === "Não" ? "Nao" : prop.milho.produtor,
            qtd_sacas_milho: prop.milho.produtor === "Sim" ? Number(prop.milho.qtdSacas) : undefined,
            qtd_ha_milho: prop.milho.produtor === "Sim" ? Number(prop.milho.qtdHa) : undefined,
            valor_milho: prop.milho.produtor === "Sim" ? desformatarValorMonetario(prop.milho.valor) : undefined,

            produtor_soja: prop.soja.produtor === "Não" ? "Nao" : prop.soja.produtor,
            qtd_sacas_soja: prop.soja.produtor === "Sim" ? Number(prop.soja.qtdSacas) : undefined,
            qtd_ha_soja: prop.soja.produtor === "Sim" ? Number(prop.soja.qtdHa) : undefined,
            valor_soja: prop.soja.produtor === "Sim" ? desformatarValorMonetario(prop.soja.valor) : undefined,

            possui_gado: prop.gadoCorte.produtor === "Não" ? "Nao" : prop.gadoCorte.produtor,
            qtd_cabecas_gado: prop.gadoCorte.produtor === "Sim" ? Number(prop.gadoCorte.qtdCabecas) : undefined,
            raca_gado: prop.gadoCorte.produtor === "Sim" ? prop.gadoCorte.raca : undefined,
            valor_gado: prop.gadoCorte.produtor === "Sim" ? desformatarValorMonetario(prop.gadoCorte.valor) : undefined,

            possui_outra_cultura: prop.outraCultura.produtor === "Não" ? "Nao" : prop.outraCultura.produtor,
            descricao_outra_cultura: prop.outraCultura.produtor === "Sim" ? prop.outraCultura.nome : undefined,
            producao_estimada: prop.outraCultura.produtor === "Sim" ? Number(prop.outraCultura.producaoEstimada) : undefined,
            valor_outra_cultura: prop.outraCultura.produtor === "Sim" ? desformatarValorMonetario(prop.outraCultura.valor) : undefined,

            possui_outra_renda: prop.outraRenda.produtor === "Não" ? "Nao" : prop.outraRenda.produtor,
            descricao_outra_renda: prop.outraRenda.produtor === "Sim" ? prop.outraRenda.nome : undefined,
            valor_outra_renda: prop.outraRenda.produtor === "Sim" ? Number(prop.outraRenda.valor) : undefined,
        })),
        // descricao: "",
        // nome_propriedade: dadosProp.nome,
        // propriedade_propria: dadosProp.propriaProp === "Não" ? "Nao" : dadosProp.propriaProp,
        // tamanho: Number(dadosProp.tamanho),
        // arrendatario: dadosProp.arrendatario === "Não" ? "Nao" : dadosProp.arrendatario,

        // produtor_leite: dadosProp.leite.produtor === "Não" ? "Nao" : dadosProp.leite.produtor,
        // produtor_cafe: dadosProp.cafe.produtor === "Não" ? "Nao" : dadosProp.cafe.produtor,
        // produtor_milho: dadosProp.milho.produtor === "Não" ? "Nao" : dadosProp.milho.produtor,
        // produtor_soja: dadosProp.soja.produtor === "Não" ? "Nao" : dadosProp.soja.produtor,
        // possui_gado: dadosProp.gadoCorte.produtor === "Não" ? "Nao" : dadosProp.gadoCorte.produtor,
        // possui_outra_cultura: dadosProp.outraCultura.produtor === "Não" ? "Nao" : dadosProp.outraCultura.produtor,
        // possui_outra_renda: dadosProp.outraRenda.produtor === "Não" ? "Nao" : dadosProp.outraRenda.produtor,

        valor_solicitacao: desformatarValorMonetario(dadosSolicitacao.valor),
        prazo_solicitacao: dadosSolicitacao.prazo,
        observacoes: dadosSolicitacao.observacoes,

    }

    //Cadastral
    if (attCadastral.possuiConjuge === "Sim") {
        params.nome_conjuge = attCadastral.conjuge
        params.cpf_conjuge = desformatarCPFCNPJ(attCadastral.document)
    }

    //Propriedade
    // if (dadosProp.arrendatario === "Sim") {
    //     params.vencimento_contrato = dadosProp.vencimentoContrato.format('YYYY-MM-DD')
    // }
    // if (dadosProp.leite.produtor === "Sim") {
    //     params.media_diaria_leite = Number(dadosProp.leite.mediaDiaria)
    //     params.qtd_vacas = Number(dadosProp.leite.qtdVacas)
    //     params.valor_leite = desformatarValorMonetario(dadosProp.leite.valor)
    // }
    // if (dadosProp.cafe.produtor === "Sim") {
    //     params.qtd_sacas_cafe = Number(dadosProp.cafe.qtdSacas)
    //     params.qtd_ha_cafe = Number(dadosProp.cafe.qtdHa)
    //     params.valor_cafe = desformatarValorMonetario(dadosProp.cafe.valor)
    // }
    // if (dadosProp.milho.produtor === "Sim") {
    //     params.qtd_sacas_milho = Number(dadosProp.milho.qtdSacas)
    //     params.qtd_ha_milho = Number(dadosProp.milho.qtdHa)
    //     params.valor_milho = desformatarValorMonetario(dadosProp.milho.valor)
    // }
    // if (dadosProp.soja.produtor === "Sim") {
    //     params.qtd_sacas_soja = Number(dadosProp.soja.qtdSacas)
    //     params.qtd_ha_soja = Number(dadosProp.soja.qtdSacas)
    //     params.valor_soja = desformatarValorMonetario(dadosProp.soja.valor)
    // }
    // if (dadosProp.gadoCorte.produtor === "Sim") {
    //     params.qtd_cabecas_gado = Number(dadosProp.gadoCorte.qtdCabecas)
    //     params.raca_gado = dadosProp.gadoCorte.raca
    //     params.valor_gado = desformatarValorMonetario(dadosProp.gadoCorte.valor)
    // }
    // if (dadosProp.outraCultura.produtor === "Sim") {
    //     params.descricao_outra_cultura = dadosProp.outraCultura.nome
    //     params.producao_estimada = Number(dadosProp.outraCultura.producaoEstimada)
    //     params.valor_outra_cultura = desformatarValorMonetario(dadosProp.outraCultura.valor)
    // }
    // if (dadosProp.outraRenda.produtor === "Sim") {
    //     params.descricao_outra_renda = dadosProp.outraRenda.nome
    //     params.valor_outra_renda = Number(dadosProp.outraRenda.valor)
    // }

    //Anexos
    const fileDocIdentidade = formData.get("docIdentidade")
    if(fileDocIdentidade) params.documento_identificacao = fileDocIdentidade

    const fileComprovanteEnd = formData.get("comprovanteEnd")
    if(fileComprovanteEnd) params.comprovante_endereco = fileComprovanteEnd

    const fileCertidaoCasamento = formData.get("certidaoCasamento")
    if (fileCertidaoCasamento) params.certidao_casamento = fileCertidaoCasamento

    const fileDocumentoIdConjuge = formData.get("documentoIdConjuge")
    if(fileDocumentoIdConjuge)  params.documento_identificacao_conjuge = fileDocumentoIdConjuge

    const fileCartaoProdutorRural = formData.get("cartaoProdutorRural")
    if (fileCartaoProdutorRural) params.cartao_produtor_rural = fileCartaoProdutorRural

    const fileDocPropriedade = formData.get("docPropriedade")
    if (fileDocPropriedade) params.documento_propriedade = fileDocPropriedade

    const fileDeclaracaoIRPF = formData.get("declaracaoIRPF")
    if (fileDeclaracaoIRPF) params.declaracao_irpf = fileDeclaracaoIRPF

    const fileDeclaracaoIRPFRecibo = formData.get("declaracaoIRPFRecibo")
    if (fileDeclaracaoIRPFRecibo) params.declaracao_irpf_recibo = fileDeclaracaoIRPFRecibo

    const fileItr = formData.get("itr")
    if (fileItr) params.declaracao_itr = fileItr

    const fileItrRecibo = formData.get("itrRecibo")
    if (fileItrRecibo) params.declaracao_itr_recibo = fileItrRecibo

    const fileCcir = formData.get("ccir")
    if (fileCcir) params.certificado_cadastro_imovel_rural = fileCcir

    const fileCcar = formData.get("car")
    if (fileCcar) params.cadastro_ambiental_rural = fileCcar

    return params
}

export function tratativaSalvarForm(
    cliente: any,
    attCadastral: any,
    dadosProp: any,
    dadosSolicitacao: any,
    enviarAnexos?: any
) {
    let formData = new FormData();
    const propsArquivos = [
        'docIdentidade',
        'comprovanteEnd',
        'cartaoProdutorRural',
        'docPropriedade',
        'declaracaoIRPF',
        'declaracaoIRPFRecibo',
        'itr',
        'itrRecibo',
        'ccir',
        'car',
    ]

    for (const chave in enviarAnexos) {
        if (Object.prototype.hasOwnProperty.call(enviarAnexos, chave)) {
            const file = enviarAnexos[chave as keyof typeof enviarAnexos];
            if (file) {
                formData.append(chave, file);
            }
        }
    }

    for (const prop in enviarAnexos) {
        if (enviarAnexos[prop] instanceof File) {
            enviarAnexos[prop] = enviarAnexos[prop].name
        }
    }

    const params = {
        cliente,
        attCadastral,
        dadosProp: {
            ...dadosProp,
            vencimentoContrato: dadosProp.vencimentoContrato?.format('YYYY-MM-DD') || undefined
        },
        dadosSolicitacao,
        enviarAnexos: enviarAnexos
    }

    const arquivos = propsArquivos.map((prop) => formData.get(prop))
    return { params, arquivos }
}

export function tratativaDownloadForm(data: string, arquivos: IRascunhoArquivo[]) {
    const objFormulario = JSON.parse(data);
    let dadosProp = objFormulario.dadosProp;
    if (!Array.isArray(dadosProp)) {
        dadosProp = Object.values(dadosProp);
    }
    const newEnviarAnexos = objFormulario.enviarAnexos;

    const files = arquivos.map((rascunho) => {
        const blob = new Blob([new Uint8Array(atob(rascunho.base64).split("").map(char => char.charCodeAt(0)))], { type: rascunho.tipo });
        return new File([blob], rascunho.nome, {
            type: rascunho.tipo,
            lastModified: Date.parse(rascunho.created_at),
        });
    });

    files.forEach((file) => {
        const keys = Object.keys(newEnviarAnexos);
        for (const key of keys) {
            if (newEnviarAnexos[key] === file.name) {
                newEnviarAnexos[key] = file;
            }
        }
    });

    const params = {
        ...objFormulario,
        dadosProp: dadosProp.map((prop: TInfoDadosPropriedade) => ({
            ...prop,
            vencimentoContrato: prop.vencimentoContrato ? moment(prop.vencimentoContrato, 'YYYY-MM-DD') : undefined
        })),
        enviarAnexos: newEnviarAnexos
    };

    return params;
}